import React, { ReactNode } from 'react'
import { useResponsive } from '../../../utils/hooks'
import { WhiteLabelLayout } from './WhiteLabelLayout'
import { DefaultLayout } from './DefaultLayout'
import RootStore from '../../../store'
import { observer } from 'mobx-react-lite'

export interface LayoutProps {
  children: ReactNode
  showsBackButton?: boolean
  onBackPress?: () => void
  contentWidth?: number | string
  contentStyle?: any
}

export default observer((props: LayoutProps) => {
  const { sm, screenWidth } = useResponsive()
  const contentWidth =
    props.contentWidth ?? (screenWidth < 500 ? '90%' : sm ? 500 : 400)
  return RootStore.branding ? (
    <WhiteLabelLayout {...props} contentWidth={contentWidth}>
      {props.children}
    </WhiteLabelLayout>
  ) : (
    <DefaultLayout {...props} contentWidth={contentWidth}>
      {props.children}
    </DefaultLayout>
  )
})
